import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Spin, Form, Breadcrumb } from "antd";
import get from "lodash/get";
import dayjs from "dayjs";
import { useMediaQuery } from "react-responsive";
import requireAuth from "../../hocs/requireAuth";
import { CalendarOutlined, LineChartOutlined } from "@ant-design/icons";

import { fetchCompanies } from "../../redux/actions/companyActions";
import HeaderSelector from "../../components/reports/dayDetailReport/headerSelector";
import {
  fetchMultiydayreport,
} from "../../redux/actions/downloadPdfAction";

import { getCurrentDateRange } from "../../utilities/report";
import { SUPER_ADMIN_ROLE_ACCESS, ORGANISATION_ADMIN_ROLE_IDs, ORGANISATION_MANAGER_IDs, ORGANISATION_SUPERVISORS_IDs } from "../../constants/userRoles";


const PageBreadcrumb = ({ title }) => {
  return (
    <Breadcrumb
      style={{ fontSize: "14px" }}
      items={[
        {
          title: <LineChartOutlined style={{ fontSize: "16px" }} />,
        },
        {
          title: (
            <>
              <CalendarOutlined style={{ fontSize: "16px" }} />
              <span>{title}</span>
            </>
          ),
        },
        {
          title: "Detail Report",
        },
      ]}
    />
  );
};
const initialState = {
  company: undefined,
  templateType: undefined,
  interval: "week",
  date: getCurrentDateRange("week", dayjs()),
  date2: dayjs(),
};
const DayDetailReportScreen = (props) => {
  const { isSameDay } = props;
  const [filter, setFilters] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [config, setConfig] = useState(null);
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [form] = Form.useForm();
  const dispatch = useDispatch();

  const setinitialCompany = (company) => {
    setFilters({
      ...filter,
      templateType: undefined,
      company,
    });
    setConfig({
      ...config,
      companies: [company],
      template_types: get(company, "template_access_list"),
    });
    form.setFieldsValue({
      template_type: undefined,
      Company: get(company, "id"),
    });
  };

  const getCompanies = () => {
    setLoading(true);
    dispatch(fetchCompanies())
      .then((result) => {
        if (result.length === 1) {
          setinitialCompany(result[0]);
        } else {
          setConfig({ companies: result });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  const onDownloadReport = () => {
    setLoading(true);
    const query = {
      company_uuid: get(filter, "company.id"),
      type: get(filter, "templateType"),
      from_date: isSameDay
        ? dayjs(get(filter, "date.0")).format("YYYY-MM-DD")
        : dayjs(get(filter, "date2")).format("YYYY-MM-DD"),
      to_date: isSameDay
        ? dayjs(get(filter, "date.1")).format("YYYY-MM-DD")
        : dayjs(get(filter, "date2")).format("YYYY-MM-DD"),
    };
    const type = isSameDay ? "day-summary-report" : "time-summary-report";
    dispatch(fetchMultiydayreport(query, type))
      .then((result) => {
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getCompanies();
  }, []);

  return (
    <div className={`${isMobile ? "" : "p-2"} h-full flex flex-col`}>
      <div className="flex flex-row justify-between pb-4">
        <div>
          <PageBreadcrumb title={isSameDay ? "Multi-Day" : "Day"} />
        </div>
        <div></div>
      </div>

      <div className="h-full rounded-xl overflow-hidden bg-white flex-1 overflow-y-auto scrollbar-hidden pb-5 min-w-full ">
        <Form form={form}>
          <Spin spinning={loading}>
            <HeaderSelector
              isSameDay={isSameDay}
              form={form}
              filter={filter}
              config={config}
              setConfig={setConfig}
              setFilters={setFilters}
              getDetails={onDownloadReport}
            />
          </Spin>
        </Form>
      </div>
    </div>
  );
};

export default requireAuth(DayDetailReportScreen,[
  ...SUPER_ADMIN_ROLE_ACCESS,
  ...ORGANISATION_ADMIN_ROLE_IDs,
  ...ORGANISATION_MANAGER_IDs,
  ...ORGANISATION_SUPERVISORS_IDs
]);
